/* Créée par Incipit Studio — Questionnaire KAARZ */
if (!customElements.get('kaarz-questionnaire')) {
  customElements.define('kaarz-questionnaire', class extends HTMLElement {
    set busy(value) { this._busy=value; this.toggleAttribute('data-transitioning',Boolean(value)); }
    get busy() { return this._busy; }
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.events = new AbortController();
      this.signal = this.events.signal;
      this.rules = window.KaarzQuizRules;
      if (!this.rules) return;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.stage = this.querySelector('.kqc-stage');
      this.steps = [...this.querySelectorAll('.kqc-step')];
      this.loading = this.querySelector('.kqc-loading');
      this.progress = this.querySelector('.kqc-progress');
      this.answers = {};
      this.index = -1;
      this.animations = [];
      this.pending = new Set();
      this.generation = 0;
      this.external = [];
      this.restore();
      this.querySelector('[data-start]').disabled = false;
      this.addEventListener('click', e => this.click(e), {signal:this.signal});
      this.addEventListener('change', e => this.change(e), {signal:this.signal});
      this.addEventListener('input', e => {
        if (e.target.matches('[name="vehicle"]')) {
          this.answers.vehicle = e.target.value.trim().slice(0,100);
          this.save(); this.error('');
        }
      }, {signal:this.signal});
      this.addEventListener('submit', e => { e.preventDefault(); this.next(); }, {signal:this.signal});
      this.stage.addEventListener('keydown', e => this.keydown(e), {signal:this.signal});
      window.addEventListener('pagehide', () => { this.cancelPending(); this.unlock(); }, {signal:this.signal});
      window.addEventListener('pageshow', e => {
        if (e.persisted && !this.stage.hidden) { this.lock(); this.loading.hidden=true; this.show(5, false); }
      }, {signal:this.signal});
      this.header = document.querySelector('kaarz-header')?.closest('.shopify-section');
      this.header?.classList.add('kqc-header-overlay');
      this.measure = () => {
        const rect = this.getBoundingClientRect();
        // En introduction, sa position dans le document inclut la barre d’annonce.
        if (this.stage.hidden) this.style.setProperty('--kqc-announcement', Math.max(0,rect.top + window.scrollY)+'px');
        const bar = this.header?.querySelector('.kn-bar');
        if (bar) this.style.setProperty('--kqc-nav', bar.getBoundingClientRect().height+'px');
      };
      this.measure();
      window.addEventListener('resize', this.measure, {signal:this.signal});
      this.resize = new ResizeObserver(this.measure);
      document.querySelectorAll('.shopify-section-group-header-group').forEach(el => this.resize.observe(el));
      if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
      this.initCars();
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', e => {
          const step = this.steps.findIndex(s => s.dataset.blockId === e.detail.blockId);
          if (step >= 0) { this.open(false); this.show(step,false); }
          else if (e.detail.blockId === this.loading.dataset.blockId) {
            this.open(false);this.cancelPending();this.steps.forEach(s=>{s.hidden=true;s.inert=true;});
            this.progress.hidden=true;this.loading.hidden=false;
            this.loadingError('Aperçu de la préparation du résultat.',false);
          } else if (e.target.closest?.('kaarz-questionnaire') === this) this.close();
        }, {signal:this.signal});
        document.addEventListener('shopify:section:select', e => {
          if (e.target.contains(this)) this.close();
        }, {signal:this.signal});
      }
      if (new URL(location.href).searchParams.get('reprendre') === '1') {
        const missing = this.rules.keys.findIndex(key => !this.answers[key]);
        this.open(false); this.show(missing < 0 ? 5 : missing,false);
      }
    }
    disconnectedCallback() {
      this.cancelPending(); this.events?.abort(); this.resize?.disconnect(); this.carObserver?.disconnect();
      clearInterval(this.carTimer); this.unlock(); this.header?.classList.remove('kqc-header-overlay'); this.initialized=false;
    }
    restore() {
      try {
        const saved = window.KaarzQuizState?.get() || JSON.parse(sessionStorage.getItem(this.rules.storageKey));
        if (saved?.version === 1) this.answers = this.rules.clean(saved.answers);
      } catch (_) { /* Le questionnaire fonctionne aussi sans stockage. */ }
      for (const step of this.steps) {
        for (const input of step.querySelectorAll('input')) {
          if (input.type === 'radio') input.checked = this.answers[input.name] === input.value;
          else input.value = this.answers.vehicle || '';
        }
      }
    }
    save() {
      this.answers = this.rules.clean(this.answers);
      this.payload = {version:1, answers:this.answers, recommendation:this.rules.recommend(this.answers), updatedAt:Date.now()};
      try { sessionStorage.setItem(this.rules.storageKey,JSON.stringify(this.payload)); } catch (_) {}
    }
    async click(e) {
      const button = e.target.closest('button');
      if (!button || button.disabled) return;
      if (button.hasAttribute('data-start')) this.open();
      if (button.hasAttribute('data-prev') && !this.busy) {
        if (this.index <= 0) this.close(); else this.show(this.index-1);
      }
      if (button.hasAttribute('data-edit')) { this.cancelPending(); this.loading.hidden=true; this.show(5,false); }
      if (button.hasAttribute('data-retry')) this.finish();
    }
    change(e) {
      const input = e.target;
      if (input.type !== 'radio' || this.busy) return;
      this.answers[input.name] = input.value; this.save(); this.error('');
      // Les flèches clavier sélectionnent ; Entrée/Suivant confirme. Un clic avance automatiquement.
      if (this.keyboardSelection || window.Shopify?.designMode) return;
      const token=this.generation;
      this.busy=true;
      this.wait(this.reduced.matches ? 0 : 280).then(() => {
        if (token !== this.generation || !this.isConnected) return;
        this.busy=false; this.next();
      });
    }
    keydown(e) {
      this.keyboardSelection = ['ArrowLeft','ArrowRight','ArrowUp','ArrowDown',' '].includes(e.key);
      if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
      if (this.busy && e.key !== 'Tab') {e.preventDefault();return;}
      if (e.key !== 'Tab') return;
      const focusable = [...this.stage.querySelectorAll('button:not([disabled]),input,[tabindex="0"],a[href]')]
        .filter(el => el.getClientRects().length && !el.closest('[inert]'));
      const first=focusable[0],last=focusable.at(-1);
      if (e.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) {e.preventDefault();last?.focus();}
      else if (!e.shiftKey && (document.activeElement === last || !focusable.includes(document.activeElement))) {e.preventDefault();first?.focus();}
    }
    lock() {
      if (this.locked) return;
      this.locked=true; this.scrollPosition=window.scrollY;
      this.bodyStyles={position:document.body.style.position,top:document.body.style.top,width:document.body.style.width,overflow:document.body.style.overflow};
      Object.assign(document.body.style,{position:'fixed',top:-this.scrollPosition+'px',width:'100%',overflow:'hidden'});
      let branch=this.stage;
      while (branch && branch !== document.body) {
        for (const sibling of branch.parentElement?.children || []) {
          if (sibling === branch || ['SCRIPT','STYLE','LINK'].includes(sibling.tagName)) continue;
          this.external.push([sibling,sibling.inert]); sibling.inert=true;
        }
        branch=branch.parentElement;
      }
    }
    unlock() {
      if (!this.locked) return;
      for (const [el,inert] of this.external) el.inert=inert;
      this.external=[]; Object.assign(document.body.style,this.bodyStyles);
      this.locked=false; window.scrollTo({top:this.scrollPosition,behavior:'instant'});
    }
    open(animate=true) {
      if (this.stage.hidden) {
        this.returnFocus=document.activeElement; this.stage.hidden=false; this.lock();
        this.keyboardSelection=false;
        this.show(0,false);
        if (animate && !this.reduced.matches) this.animations.push(this.stage.animate([{transform:'translateX(100%)'},{transform:'translateX(0)'}],{duration:650,easing:'cubic-bezier(.22,.61,.36,1)'}));
      }
    }
    close() {
      this.cancelPending(); this.stage.hidden=true; this.loading.hidden=true;
      this.steps.forEach(s=>{s.hidden=true;s.inert=true;});
      this.index=-1; this.unlock(); this.measure?.(); this.returnFocus?.focus({preventScroll:true});
    }
    wait(ms) {
      return new Promise(resolve => {
        const entry={resolve}; entry.id=setTimeout(()=>{this.pending.delete(entry);resolve();},ms); this.pending.add(entry);
      });
    }
    cancelPending() {
      this.generation=(this.generation||0)+1; this.busy=false;
      for (const entry of this.pending || []) {clearTimeout(entry.id);entry.resolve();}
      this.pending?.clear(); this.fetchController?.abort();
      for (const animation of this.animations || []) animation.cancel(); this.animations=[];
    }
    error(message) {
      const el=this.steps[this.index]?.querySelector('.kqc-error');
      if (el) {el.textContent=message;el.hidden=!message;}
    }
    next() {
      if (this.busy || this.index < 0) return;
      const key=this.rules.keys[this.index];
      this.save();
      if (!this.answers[key]) {
        this.error(this.index === 0 ? 'Indiquez le modèle de votre voiture pour continuer.' : 'Sélectionnez une réponse pour continuer.');
        this.steps[this.index].querySelector('input')?.focus();return;
      }
      if (this.index === 5) this.finish(); else this.show(this.index+1);
    }
    async show(index,animate=true) {
      this.cancelPending(); const token=this.generation;
      const old=this.steps[this.index], next=this.steps[index];
      if (!next) return;
      const direction=index >= this.index ? 1 : -1;
      this.index=index; this.loading.hidden=true; this.progress.hidden=false;
      // Charge uniquement l’écran courant et le suivant en avance.
      [next,this.steps[index+1] || this.loading].forEach(screen=>screen?.querySelectorAll('img').forEach(img=>{img.loading='eager';}));
      this.progress.setAttribute('aria-valuenow',String(index+1));
      this.progress.setAttribute('aria-valuetext',`Question ${index+1} sur 6`);
      const amounts=[.0625,.25,.5,.677,.8125,.9375];
      this.querySelector('.kqc-progress-fill').style.transform=`scaleX(${amounts[index]})`;
      this.steps.forEach(s=>{if(s!==old&&s!==next){s.hidden=true;s.inert=true;}});
      next.hidden=false; next.inert=false; next.querySelector('.kqc-panel').scrollTop=0;
      if (old && old !== next) old.inert=true;
      this.busy=true;
      if (animate && old && old !== next && !this.reduced.matches) {
        const opts={duration:600,easing:'cubic-bezier(.22,.61,.36,1)'};
        // Le prochain écran entre par la droite ; retour symétrique vers la gauche.
        this.animations=[old.animate([{transform:'translateX(0)'},{transform:`translateX(${-100*direction}%)`}],opts),next.animate([{transform:`translateX(${100*direction}%)`},{transform:'translateX(0)'}],opts)];
        await Promise.all(this.animations.map(a=>a.finished.catch(()=>{})));
      }
      if (token !== this.generation) return;
      this.steps.forEach(s=>{if(s!==next){s.hidden=true;s.inert=true;}});
      this.animations=[];this.busy=false;
      next.querySelector('.kqc-title')?.focus({preventScroll:true});
    }
    async finish() {
      this.save();
      if (!this.payload.recommendation) return;
      this.payload = window.KaarzQuizState?.complete(this.payload) || this.payload;
      this.cancelPending(); const token=this.generation;
      this.steps.forEach(s=>{s.hidden=true;s.inert=true;});
      this.progress.hidden=true; this.loading.hidden=false; this.busy=true;
      this.querySelector('[data-loading-actions]').hidden=true;
      this.querySelector('[data-loading-title]').focus({preventScroll:true});
      this.dispatchEvent(new CustomEvent('kaarz:configuration-ready',{bubbles:true,detail:this.payload}));
      const minimum=this.wait(1500+Math.random()*1500);
      const raw=this.dataset.resultUrl;
      if (!raw || window.Shopify?.designMode) {
        await minimum;
        if (token !== this.generation) return;
        this.loadingError(window.Shopify?.designMode ? 'Aperçu terminé. La redirection est désactivée dans l’éditeur de thème.' : 'Votre sélection est prête. La page de résultat n’est pas encore disponible.',false);
        return;
      }
      try {
        const url=new URL(raw,location.origin);
        if (url.origin !== location.origin || url.pathname === location.pathname) throw new Error('destination');
        this.fetchController=new AbortController();
        const timeout=setTimeout(()=>this.fetchController?.abort(),12000);
        try {
          const response=await fetch(url.href,{credentials:'same-origin',signal:this.fetchController.signal});
          if (!response.ok) throw new Error('network');
          await response.text();
        } finally { clearTimeout(timeout); }
        await minimum;
        if (token !== this.generation) return;
        // Secours si sessionStorage est bloqué : codes seulement, jamais le modèle de voiture dans l’URL.
        const transferable={version:1,answers:{...this.answers}}; delete transferable.answers.vehicle;
        url.hash='kaarz='+encodeURIComponent(JSON.stringify(transferable));
        location.assign(url.href);
      } catch (_) {
        await minimum;
        if (token !== this.generation) return;
        this.loadingError('La page de résultat n’a pas pu être chargée. Vos réponses sont conservées ; vous pouvez réessayer.',true);
      }
    }
    loadingError(message,retry) {
      this.busy=false;this.querySelector('[data-loading-message]').textContent=message;
      this.querySelector('[data-loading-actions]').hidden=false;
      this.querySelector('[data-retry]').hidden=!retry;
    }
    initCars() {
      const area=this.querySelector('.kqc-cars'); if (!area) return;
      this.cars=[...area.querySelectorAll('.kqc-car')]; this.carIndex=0;
      this.carObserver=new IntersectionObserver(entries=>{this.carVisible=entries[0].isIntersecting;},{threshold:.05});
      this.carObserver.observe(area);
      this.carTimer=setInterval(async()=>{
        if (!this.carVisible || document.hidden || !this.stage.hidden || this.reduced.matches || !matchMedia('(max-width:989px)').matches || this.carBusy) return;
        this.carBusy=true;
        const index=(this.carIndex+1)%this.cars.length, next=this.cars[index];
        try {
          if (next.dataset.src) { next.src=next.dataset.src; delete next.dataset.src; }
          await next.decode();
          if (!this.isConnected) return;
          this.cars[this.carIndex].classList.remove('is-active');next.classList.add('is-active');this.carIndex=index;
        } catch (_) {} finally {this.carBusy=false;}
      },Number(this.dataset.carInterval)||1000);
      this.addEventListener('pointerdown',()=>{this.keyboardSelection=false;},{signal:this.signal});
    }
  });
}
